import "./ModalViewRules.scss";
import { useTranslation } from "react-i18next";
import React, { useEffect, useState } from "react";
import { Button, Col, Modal, Row, Select, Switch, Input, Table, Icon, Upload, message } from "antd";
import { camelizerHelper } from "../../../../helpers/";
import { getValoresParametroClientePromise, uploadValoresParamRulePromise, getMonitorHistorialReglaPromise } from "../../promises";
import { ReportService } from "../../../../services";
import moment from "moment";
import { Tooltip } from 'antd';

const ModalViewRules = ({
  ruleItems,
  modalItem,
  onCancel,
  handleChangeModal,
}) => {
  const { t } = useTranslation()
  const [itemCopy, setItemCopy] = useState({});
  const [changesCounter, setChangesCounter] = useState(0);
  const [valoresParams, setValoresParams] = useState(null);
  const [isVisibleModalValores, setIsVisibleModalValores] = useState(false);
  const [tableHeight, setTableHeight] = useState(0);
  const [exportLoading, setExportLoading] = useState(false);
  const [importLoading, setImportLoading] = useState(false);
  const [isTableLoading, setIsTableLoading] = useState(true);
  const [paramId, setParamId] = useState(null);
  const [historyTable, setHistoryTable] = useState([]);

  const { confirm } = Modal;
  
  useEffect(() => {
    if (modalItem) {
      setItemCopy(JSON.parse(JSON.stringify(modalItem)));
    }
    const calcularAltura = () => {
      const alturaDisponible = window.innerHeight - 350; // margen inferior opcional
      setTableHeight(alturaDisponible);
    };

    loadHistory();

    calcularAltura();
    window.addEventListener('resize', calcularAltura);
    return () => window.removeEventListener('resize', calcularAltura);
  }, []);

  const loadHistory = () => {
    getMonitorHistorialReglaPromise(modalItem.id).then (response => {
      setHistoryTable(response.data)
    })
  }

  const updateModal = async (item) => {
    await handleChangeModal(item)
    loadHistory()
  }

  const handleEditItemCopy = (parameterIndex, parameter, value) => {
    const parametersCollection = itemCopy.params;
    parametersCollection[parameterIndex].value = value;
    setItemCopy({ ...itemCopy, params: parametersCollection });
    setChangesCounter(changesCounter + 1);
  };

  const handleChangeField = (field, value) => {
    setItemCopy({ ...itemCopy, [field]: value });
    setChangesCounter(changesCounter + 1);
  };

  const openValoresParametros = (paramId) => {
    setIsTableLoading(true)
    setParamId(paramId)
    getValoresParametroClientePromise(paramId).then(r => {
      if(r?.records) setValoresParams(r.records)
      setIsTableLoading(false)
    })
    setIsVisibleModalValores(true)
  }

  const closeModalValores = () => {
    setIsVisibleModalValores(false)
  }

  const tableColumns = [
    {
      title: "Fecha",
      dataIndex: "fecha",
      render: (text) => {
        return text !== null ? moment(text).format("DD/MM/YYYY HH:mm") : "-";
      },
    },
    {
      title: "Usuario",
      dataIndex: "username",
    },
    // {
    //   title: t("messages.aml.view"),
    //   width: "70px",
    //   render: (text, record) => {
    //     return (
    //       <>
    //         {record.description !== null && record.description !== '' && (
    //           <div
    //             className="comments-files"
    //             onClick={(e) => {
    //               handleOnModalComments(record)

    //             }}
    //           >
    //             <Icon type="folder-open" />
    //           </div>
    //         )}
    //       </>
    //     );
    //   },
    // },
  ];

  const tableColumnsValores = [
    {
      title: "Código",
      dataIndex: "codigo",
      width: '20%',
    },
    {
      title: "Nombre",
      dataIndex: "nombre",
      width: '60%',
    },
    {
      title: "Seleccionado",
      dataIndex: "seleccionado",
      width: '20%',
      render: (selected) => {
        return selected ? "Sí" : "";
      }
    }
  ]

  const propsUpload = {
      accept: ".xlsx, .xls",
      beforeUpload: file => {
        if(file) {
        const isExcel =
            file.type === "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" ||
            file.type === "application/vnd.ms-excel";

        if (!isExcel) {
          message.error("Solo se permiten archivos Excel");
          return false;
        }

        const maxSizeBytes = 500 * 1024;
        if (file.size > maxSizeBytes) {
          message.error("Error: El archivo supera el tamaño permitido (500Kb)");
          return false;
        }

          confirm({
            title: (
                <>
                  El listado de riesgo será reemplazado, ¿desea continuar?
                </>
            ),
            okText: "Si",
            cancelText: "No",
            onOk: async () => {
              await handleImport(file)
            },
            onCancel() {
              return
            },
          });
        }
        return false
      },
      multiple: false,
      showUploadList: false
  }

  const handleExport = async () => {
    setExportLoading(true)
    await ReportService.read('/transaction/exportValoresParametroCliente', {paramId}, null, 'valores-parametros.xlsx')
    setExportLoading(false)
  }

  const handleImport =  async (file) => {
      setImportLoading(true)
      const formData = new FormData()
          formData.append('file', file)
          formData.append('paramId', paramId)
          formData.append('ruleId', modalItem.id)
          setIsTableLoading(true)
      await uploadValoresParamRulePromise(formData).then(response => {
        setImportLoading(false)
        if(response.status === "OK") {
          setIsTableLoading(false)
          openValoresParametros(paramId)
          loadHistory()
          message.success("Se importó el archivo correctamente")
        }else{
          message.error(response.detail)
        }
      })
  }

  const getTooltipParameterMultiple = (param) => {
    const rules = ruleItems.filter(r => r.id !== modalItem.id && r.params).map(r => {
      if(r.params.filter(p => p.id === param.id).length > 0) {
        return r
      }else {
        return null
      }
    }).filter(r => r !== null)
    if(rules.length > 0) {
      return "Importante: si modifica este parametro las siguientes reglas serán modificadas: " + (rules.map(r => r.code).join(", "))
    }
    return null
  }

  return (
    <Modal
      className="modal-view-rules"
      footer={null}
      header={null}
      title={t("messages.aml.rule") + " " + t("messages.aml.monitor.alertas." + modalItem.type)}
      onCancel={onCancel}
      visible={true}
      width="800px"
      style={{top:10}}
    >
      <>
      <Row>
        <Col span={12}>
          <h2>{modalItem.name}</h2>
        </Col>
        <Col span={4} offset={5}>
          <div style={{marginTop: 4}}>
            Estado <Switch 
                      defaultChecked={modalItem.status === "ACTIVE"}
                      onChange={(value) => {
                        handleChangeField("status", value ? "ACTIVE" : "INACTIVE")
                      }}                    
                      checkedChildren={<Icon type="check" />}
                      unCheckedChildren={<Icon type="close" />} />
          </div>
        </Col>
        <Col span={2}>
          <div style={{textAlign: 'center'}}>
            <Button
              type="ghost"
              onClick={() => updateModal(itemCopy)}
              disabled={changesCounter === 0}
            >
              Guardar
            </Button>
          </div>
        </Col>
      </Row>
      <hr/>
        <div className="section-modal-view-rules-wrapper">
          <Row gutter={[20, 20]}>
            <Col span={24}>
              <label>Descripción</label>
              <Input.TextArea
                defaultValue={null}
                autoSize={{ minRows: 2, maxRows: 10 }}
                style={{ width: "100%" }}
                disableds
                value={modalItem.description}
              />
            </Col>
            {(modalItem.type === "DEMOGRAFICA" || modalItem.type === "TRANSACCIONAL") && (
            <Col span={24}>
              <label>Script Regla</label>
              <Input.TextArea
                defaultValue={modalItem.scriptRule}
                onChange={(e) => handleChangeField("scriptRule", e.target.value)}
                autoSize={{ minRows: 2, maxRows: 10 }}
                style={{ width: "100%" }}
              />
            </Col>
            )}
            <Col span={8}>
              <label>Riesgo</label>
              <Select
                // size="small"
                defaultValue={modalItem.score}
                style={{ width: "100%" }}
                onChange={(value) => handleChangeField("score", value)}
              >
                <Select.Option key={1} value={1}>Bajo</Select.Option>
                <Select.Option key={2} value={2}>
                  Medio
                </Select.Option>
                <Select.Option key={3} value={3}>
                  Alto
                </Select.Option>
                <Select.Option key={4} value={4}>
                  Crítico
                </Select.Option>
              </Select>
            </Col>
            <Col span={8}>
              <label>Código de Regla</label>
              <Input
                disabled
                defaultValue={modalItem.code}
              />
            </Col>
          </Row>
        </div>
        {itemCopy.params?.length > 0 &&
          <Row className="field-section-row">
            <Col span={24}>
                <div className="title-section">
                    <Row>
                        <Col span={22}>
                          <h4>Parámetros</h4>
                        </Col>
                    </Row>
                </div>
            </Col>
            <div className="section-modal-view-rules-wrapper">
              <Row gutter={[20, 20]}>
                {itemCopy.params.map((parameter, index) => (
                  <Col
                    span={itemCopy.params.length === 1 ? 24 : 12}
                    key={index}
                  >
                   {getTooltipParameterMultiple(parameter) ? (
                      <Tooltip title={getTooltipParameterMultiple(parameter)}>
                        <span style={{color:'red'}}>*</span> <label>{parameter.name}</label>
                      </Tooltip>
                    ) : (
                      <label>{parameter.name}</label>
                    )}
                    { parameter.type === "S" ?
                      <Input
                        defaultValue={parameter.value}
                        onChange={({ target }) => {
                          handleEditItemCopy(index, parameter, target.value);
                        }}
                      />
                      :
                      <div>
                        <Button style={{width:'100%'}} onClick={() => openValoresParametros(parameter.id)}>Ver Detalles</Button>
                      </div>
                    }
                  </Col>
                ))}
              </Row>
            </div>
          </Row>
        }
        <Row className="field-section-row" gutter={[20,20]}>
          <Col span={24}>
              <div className="title-section">
                  <Row>
                      <Col span={22}>
                        <h4>Historial de Cambios</h4>
                      </Col>
                  </Row>
              </div>
          </Col>
          <div className="section-modal-view-rules-wrapper">
            <Col xs={24}>
              <Table
                pagination={{ pageSize: 5 }}
                className="table-data"
                dataSource={historyTable}
                columns={tableColumns}
                size="small"
                expandedRowRender={record => {
                  return <pre>{record.descripcion}</pre>}
                }
              />
            </Col>
          </div>
        </Row>
      </>
      {/* {isModalCommentsVisble && (
        <ModalComments
          onCancel={handleModalCommentsCancel}
          comment={modalComment}
        />
      )} */}
      { isVisibleModalValores &&
        <Modal
          footer={[<Button onClick={closeModalValores}>{t('messages.aml.btnClose')}</Button>]}
          header={null}
          title={"Valores  Parámetro: " + modalItem.name}
          onCancel={closeModalValores}
          visible={true}
          width="900px"
          style={{top:5}}
        >
          <div>
            { valoresParams && 
              <Row>
                <Col span={24}>
                  <h3>Actualmente tiene seleccionado {valoresParams.filter(v => v.seleccionado).length} elementos de riesgo, a continuación se presenta el detalle.</h3>
                </Col>
              </Row>
            }
            <Row gutter={[0, 10]}>
              <Col span={1}>
                1.
              </Col>
              <Col span={19}>
                Para modificar el listado, descargue el archivo Excel y marque con una "x" los elementos que desea incorporar.
              </Col>
              <Col span={4} style={{textAlign: 'right'}}>
                <Button loading={exportLoading} onClick={() => {handleExport()}}>{!exportLoading && <Icon type="arrow-down" />} Exportar </Button>
              </Col>
            </Row>
            <Row gutter={[0, 10]}>
              <Col span={1}>
                2.
              </Col>
              <Col span={19}>
                Una vez realizados los cambios, puede subir el archivo actualizado. Recuerde que el nuevo archivo reemplazará el listado anterior y no debe contener saltos de filas para asegurar una carga exitosa.
              </Col>
              <Col span={4} style={{textAlign: 'right'}}>
                <Upload {...propsUpload}>
                  <Button loading={importLoading}>{!importLoading && <Icon type="arrow-up" />} Importar </Button>
                </Upload>
              </Col>
            </Row>
            <Table
              pagination={false}
              dataSource={valoresParams??[]}
              columns={tableColumnsValores}
              size="small"
              scroll={{ y: tableHeight }}
              loading={isTableLoading}
              style={{marginTop:10}}
            />
          </div>
        </Modal>
      }
    </Modal>
  );
};

export default ModalViewRules;
